import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Skeleton } from "@mui/material";

interface LocationBasedData {
    location: string;
}

interface ColumnNameConfig<T> {
    header: string;
    field: keyof T; 
    align?: "left" | "right" | "center";
    format?: (val: T[keyof T], row?: T) => string | number;
}

interface TableProps<T extends LocationBasedData> {
    inputData: T[];
    columns: ColumnNameConfig<T>[];
    isLoading?: boolean;
}

const SummaryStatsTable = <T extends LocationBasedData>({ inputData, columns, isLoading }: TableProps<T>) => {

    return (
        <TableContainer className="summary-table-view" component={Paper} elevation={0} sx={{
          backgroundColor: "white",
          pb: 0,
          height: "100%",
          overflowX: "auto",
          flexGrow: 1
        }}>
            <Table>
                <TableHead>
                    <TableRow className="summary-table-header">
                        <TableCell align="left">Standort</TableCell> 
                        {columns.map(col => <TableCell key={String(col.field)} align={col.align}>{col.header}</TableCell>)}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {isLoading ? (
                        <TableRow>
                            {/* skeleton for the location column */}
                            <TableCell>
                                <Skeleton animation="wave" variant="text" width="100%" />
                            </TableCell>
                            {columns.map((col) => (
                                <TableCell key={String(col.field)} align={col.align}>
                                    <Skeleton animation="wave" variant="text" width="100%" />
                                </TableCell>
                            ))}
                        </TableRow>
                    ) : inputData.length === 0 ? (
                        <TableRow>
                            <TableCell colSpan={columns.length + 1} align="center">
                                Keine Daten
                            </TableCell>
                        </TableRow>
                    ) :
                    inputData.map((row) => (
                        <TableRow key={row.location}>
                            <TableCell align="left">{row.location}</TableCell>
                            {columns.map(col => (
                                <TableCell key={String(col.field)} align={col.align}>
                                    {col.format ? col.format(row[col.field], row) : String(row[col.field])}
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default SummaryStatsTable;